import { render, staticRenderFns } from "./batchStaffIcData.vue?vue&type=template&id=5d83bba6&scoped=true&"
import script from "./batchStaffIcData.vue?vue&type=script&lang=js&"
export * from "./batchStaffIcData.vue?vue&type=script&lang=js&"
import style0 from "./batchStaffIcData.vue?vue&type=style&index=0&id=5d83bba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83bba6",
  null
  
)

export default component.exports